import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class DayTimesheetComponentCanvas extends Component {
    render() {
        const { component, isSelected, dimentionsRatio, draggable } = this.props;

        const componentWidthRatio = component.width / 1200.0;
        const componentHeightRatio = component.height / 400.0;

        const smallHeight = 50 * componentHeightRatio * dimentionsRatio;
        const mediumHeight = 200 * componentHeightRatio * dimentionsRatio;
        const bigHeight = 300 * componentHeightRatio * dimentionsRatio;
        const smallWidth = 50 * componentWidthRatio * dimentionsRatio;
        const bigWidth = 300 * componentWidthRatio * dimentionsRatio;

        const descriptionPosX = component.drawPositionX + 50 * componentWidthRatio * dimentionsRatio;
        const descriptionPosY = component.drawPositionY + 50 * componentHeightRatio * dimentionsRatio;

        const firstElementPosY = component.drawPositionY + 50 * componentHeightRatio * dimentionsRatio;
        const secondElementPosY = component.drawPositionY + 150 * componentHeightRatio * dimentionsRatio;

        const componentSecundaryColor = "#EBF5FA";
        const componentWidth = component.width * dimentionsRatio;
        const componentHeight = component.height * dimentionsRatio;

        const rowElements = [];
        let i;
        for (i = 0; i < 8; i++) {
            const rowPosX = component.drawPositionX + (400 + 100 * i) * componentWidthRatio * dimentionsRatio;
            rowElements.push(
                <Group key={i}>
                    <Rect x={rowPosX}
                        y={firstElementPosY}
                        width={smallWidth}
                        height={smallHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                    <Rect x={rowPosX}
                        y={secondElementPosY}
                        width={smallWidth}
                        height={mediumHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>
            );
        }

        return (
            <Group
                offsetX={component.offsetX}
                offsetY={component.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={component.drawPositionX}
                    y={component.drawPositionY}
                    width={componentWidth}
                    height={componentHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    <Rect x={descriptionPosX}
                        y={descriptionPosY}
                        width={bigWidth}
                        height={bigHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor} />
                </Group>

                {rowElements}
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/DayTimesheetComponentCanvas.js